<script setup>
import router from '../../routes/index';
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  // Icon-only arrow for tight headers (e.g. the table-layout conversation view).
  iconOnly: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <button
    v-if="iconOnly"
    :aria-label="buttonLabel || $t('GENERAL_SETTINGS.BACK')"
    :title="buttonLabel || $t('GENERAL_SETTINGS.BACK')"
    class="grid rounded-lg size-8 shrink-0 place-items-center cursor-pointer text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12"
    @click.capture="goBack"
  >
    <i class="i-lucide-arrow-left size-4" />
  </button>
  <button
    v-else
    class="flex items-center p-0 font-normal cursor-pointer text-n-slate-11"
    :class="buttonStyleClass"
    @click.capture="goBack"
  >
    <i class="i-lucide-chevron-left -ml-1 text-lg" />
    {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
  </button>
</template>
